export const callCenterPhoneNumber = `tel:+611300363688`

export const callCenterInternationalPhoneNumber = 'tel:+61894455391'
